import { IntercomContextValues, useIntercom as useIntercomOriginal } from 'react-use-intercom';

import { useConfig } from '@shared/contexts/ConfigContext';

export enum IntercomTourIds {
  TransactionIntegrationTile = 'intercom-tour-transaction-integration-tile',
  RadiusDataExchange = 'intercom-tour-radius-data-exchange',
}

export const useIntercom = () => {
  const { enquireUrl, intercomEnabled } = useConfig();
  const intercom = useIntercomOriginal();

  return {
    ...intercom,
    show: () => {
      if (intercomEnabled) {
        intercom.show();
      } else {
        console.log('useIntercom.show');
        window.open(enquireUrl, '_blank');
      }
    },
    showNewMessages: (prePopulatedContent?: string) => {
      if (intercomEnabled) {
        intercom.showNewMessages(prePopulatedContent);
      } else {
        console.log('useIntercom.showNewMessages', prePopulatedContent);
        window.open(enquireUrl, '_blank');
      }
    },
    trackEvent: (event: string, metaData?: object) => {
      if (intercomEnabled) {
        intercom.trackEvent(event, metaData);
      } else {
        console.log('useIntercom.trackEvent', event, metaData);
      }
    },
  } satisfies IntercomContextValues;
};
